/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ServerDefs from './defs.defs.js'

const $nsid = 'com.atproto.server.getAccountInviteCodes'

export { $nsid }

/** Get all invite codes for the current account. Requires auth. */
const main = l.query(
  $nsid,
  l.params({
    includeUsed: l.optional(l.withDefault(l.boolean(), true)),
    createAvailable: l.optional(l.withDefault(l.boolean(), true)),
  }),
  l.jsonPayload({
    codes: l.array(
      l.ref<ServerDefs.InviteCode>((() => ServerDefs.inviteCode) as any),
    ),
  }),
  ['DuplicateCreate'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
